import { IApplicationState } from '../../types/redux';

/**
 * Выбирает результаты поиска
 */
export const selectSearchingResults = ({ searchingResults }: IApplicationState) => searchingResults;
